import { UPDATE_CHAT } from "../actions/types";

const initialState = {
  chat: {},
  // user: !localStorage.getItem("user")
  //   ? userIni
  //   : JSON.parse(localStorage.getItem("user")),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_CHAT:
      let chat = state.chat;
      if (!chat.hasOwnProperty(action.payload.id)) {
        chat[action.payload.id] = [];
      }

      chat[action.payload.id].push(action.payload.chat);

      return {
        ...state,
        chat,
      };

    default:
      return state;
  }
}
